import csharpIcon from "../img/Icons/Logos/CsharpLogo.png";

export default function CSharpSkill(){
    return (
        <div className="skillTile">
            <img src={csharpIcon} alt="csharp"/>
            <div className="skillTexts">
                <h2>C-Sharp</h2>
            </div>
        </div>
    )
}